import type { RequestParameters, Variables } from 'relay-runtime';

import { fg } from '@atlaskit/platform-feature-flags/fg';

import { buildGetUrl } from './buildGetUrl';
import { calculateHeadersSize } from './calculateHeadersSize';

const MAX_QUERY_LENGTH = 2000; // Maximum allowed query length
const MAX_HEADERS_SIZE = 20 * 1024; // Maximum header size in bytes (20 KB)

export function shouldUseGetMethod({
	url: baseUrl,
	variables,
	request,
	headers,
	isServer,
}: {
	url: string;
	variables: Variables;
	request: RequestParameters;
	headers?: HeadersInit;
	isServer: boolean;
}): { isGetRequest: boolean; reason?: string } {
	if (isServer) {
		return { isGetRequest: false, reason: 'SSR' };
	}
	if (fg('hot-302159-relay-get-killswitch')) {
		return { isGetRequest: false, reason: 'Killswitch is on' };
	}

	if (request.operationKind !== 'query') {
		return { isGetRequest: false, reason: request.operationKind };
	}

	const queryLength = buildGetUrl(baseUrl, variables).length;

	const headersSize = calculateHeadersSize(headers || {});
	return queryLength <= MAX_QUERY_LENGTH && headersSize <= MAX_HEADERS_SIZE
		? { isGetRequest: true }
		: { isGetRequest: false, reason: 'URL length or headers size too large' };
}
